import { render, staticRenderFns } from "./instagram-search.vue?vue&type=template&id=72febf44&scoped=true&"
import script from "./instagram-search.vue?vue&type=script&lang=js&"
export * from "./instagram-search.vue?vue&type=script&lang=js&"
import style0 from "./instagram-search.vue?vue&type=style&index=0&id=72febf44&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72febf44",
  null
  
)

export default component.exports